const initialState = {
  count: 0,
  loading: false,
  error: null,
  toast: false,
};

// Define action types
const EMPTY = 'EMPTY';
const DECREMENT = 'DECREMENT';
const LOADING = 'LOADING';
const DONE_LOADING = 'DONE_LOADING';
const ERROR = 'ERROR';

export const ProgressReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMPTY:
      return { ...state, count: 0, toast: false, error: null };
    case DECREMENT:
      return { ...state, count: Math.max(0, state.count - 1) }; // Prevent negative count
    case LOADING:
      return { ...state, loading: true, error: null, toast: false };
    case DONE_LOADING:
      return { ...state, loading: false, error: null, toast: false };
    case ERROR:
      return { ...state, error: action.payload, toast: true, loading: false };
    default:
      return state;
  }
};
